import symbolName from "@/util/symbol-name.mjs";

export const GAME_SYMBOL_VAL: unique symbol = symbolName("val");
